<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card p-3">
                <div class="row">
                    <div class="col-12 col-lg-10">
                        <app-breadcrumb
                            subtitle="{{ selectedContienda == 'gubernatura' ? 'Detalle del Distrito' : (labels?.contienda_s == 'Municipio' ? 'Detalle del Municipio' : (labels?.contienda == 'Juntas' ? 'Detalle por Juntas' : 'Detalle del ' + labels?.contienda_s ))}}"
                            [subtitle_detalle]="'Votos por Partido Político' + (habilitar_label_candidaturas ? ' y Candidatura Independiente' : '')"
                            [estado]="_obtenerDatosService?.config?.estado"
                            [distrito]="rutas.migas?.distrito"
                            [distrito_param]="rutas.migas?.distrito_clave"
                        ></app-breadcrumb>
                        <div class="texto font-regular">
                            <p>
                                El total de votos calculado y porcentaje que se muestran, se refieren a los votos asentados en las Actas PREP hasta el momento.
                            </p>
                            <p>
                                Por presentación, los decimales de los porcentajes muestran sólo cuatro dígitos. No obstante, al considerar todos los decimales, suman 100%.
                            </p>
                        </div>
                    </div>
                    <div class="col-2 d-none d-lg-block">
                    </div>
                </div>
                <app-resumen-votacion-mobile
                    [total_num]="resumen?.total?.total"
                    [total_prc]="resumen?.total?.prc"
                ></app-resumen-votacion-mobile>
                <div class="row pb-4">
                    <div class="col">
                        <h4 class="subtitulo-seccion pleca-izquierda my-3">
                            <strong>Votos en Actas Contabilizadas</strong>
                        </h4>
                    </div>
                </div>
                <!-- TARJETAS DE ESCRITORIO -->
                <div class="container-fluid d-none d-md-none d-xl-block">
                    <!-- <div class="row dis-flex pb-1">
                        <div class="boton-scroll dis-flex cursorPointer" (click)="scrollLeft()">
                            <i class="fas fa-chevron-left" aria-hidden="true"></i>
                        </div>
                        <div class="col-11">
                            <div #widgetsContent class="row dis-flex justify-s scrollH">
                                <div *ngFor="let tarjeta of fichas; let indx = index;" class="col-6 col-sm-4 col-md-3 col-lg-2 px-1">
                                    <div class="card-resumen">
                                        <div class="encabezado dis-flex w-100 py-2">
                                            <div class="dis-flex w-100">
                                                <div class="row w-100 dis-flex"> -->
                                                    <!-- siempre comentado <img class="img-partido" *ngFor="let img of tarjeta?.imgs"  [src]="_obtenerDatosService.pathPartidos + img.toLowerCase()" > -->
                                                    <!-- <img class="img-partido" *ngFor="let img of tarjeta?.imgs"  [src]="_obtenerDatosService.pathPartidos + img" >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="cuerpo dis-flex bgGrisTenue p-2">
                                            <div class="w-50">
                                                <p>Votos</p>
                                                <p class="votos">
                                                    <strong>{{ tarjeta?.total }}</strong>
                                                </p>
                                            </div>
                                            <div class="w-50 dis-flex flex-col align-e pr-3 pr-xl-0">
                                                <p>Porcentaje</p>
                                                <p>{{ tarjeta?.porcentaje }}</p>
                                            </div>
                                        </div> -->
                                        <!-- siempre comentado <div *ngIf="!tarjeta.seleccionado" (click)="agregarElemento(tarjeta);" class="pie dis-flex bgMorado txBlanco p-2 cursorPointer">
                                            <p>Seleccionar</p>
                                        </div>
                                        <div *ngIf="tarjeta.seleccionado" (click)="eliminarElemento(tarjeta);" class="pie dis-flex bgMorado txBlanco p-2 cursorPointer seleccionado">
                                            <p>Quitar selección</p>
                                        </div> -->
                                    <!-- </div>
                                </div>
                            </div>
                        </div>
                        <div class="boton-scroll dis-flex cursorPointer" (click)="scrollRight()">
                            <i class="fas fa-chevron-right" aria-hidden="true"></i>
                        </div>
                    </div> -->

                    <div class="col-12 px-0">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <td class=""></td>
                                        <td class="fondoGrafica td-relative" *ngFor="let item of grafica_table"></td>
                                    </tr>
                                    <tr>
                                        <td class="td-relative table-borderedHeader sinBorde">
                                            <!-- <div class="my-chart-label "><b>Votos</b></div> -->
                                            <div class="linea-chart-nl line-chart-100 line-char-first ">{{ (total_votos | stringtoint) | formatmiles }}</div>
                                            <div class="linea-chart-nl line-chart-80 line-char-first ">{{ (((total_votos | stringtoint) * .8) | round) | formatmiles }}</div>
                                            <div class="linea-chart-nl line-chart-60 line-char-first ">{{ (((total_votos | stringtoint) * .6) | round) | formatmiles }}</div>
                                            <div class="linea-chart-nl line-chart-40 line-char-first ">{{ (((total_votos | stringtoint) * .4) | round) | formatmiles }}</div>
                                            <div class="linea-chart-nl line-chart-20 line-char-first ">{{ (((total_votos | stringtoint) * .2) | round) | formatmiles }}</div>
                                            <div class="linea-chart-nl line-chart-0 line-char-first ">0</div>
                                            <div class="my-chart ">
                                                <div style="height: 0px; "></div>
                                            </div>
                                        </td>
                                        <td class="fondoGrafica td-relative" *ngFor="let itemPartido of grafica_table; let indx = index;">
                                            <div class="linea-chart line-chart-100 "></div>
                                            <div class="linea-chart line-chart-80 "></div>
                                            <div class="linea-chart line-chart-60 "></div>
                                            <div class="linea-chart line-chart-40 "></div>
                                            <div class="linea-chart line-chart-20 "></div>
                                            <div class="linea-chart-nl line-chart-0 "></div>
                                            <div class="progress-bar-vertical">
                                                <div aria-valuemax="100" aria-valuemin="0" class="progress-bar progres-chart " placement="top" role="progressbar" [attr.title]="" tooltip="<p>{{ itemPartido?.header?.text }}</p><p>Total de votos: {{itemPartido?.data?.r1}}</p><p>Porcentaje: {{itemPartido?.data?.r2}}</p>"
                                                    [ngStyle]="{ 'height': itemPartido?.data?.r2,'background-color': itemPartido?.header?.color ? itemPartido?.header?.color : 'var(--bg-barra-contabilizadas)'}">
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="pdv-0">
                                            <div class="cont-alg" >
                                                <span class="px18 font-bold abttm">
                                                    <strong>Votos</strong>
                                                </span>
                                            </div>
                                        </td>
                                        <td class="text-center" *ngFor="let itemPartido of grafica_table; let indx = index;">
                                            <ng-container>
                                                <div class="dis-flex">
                                                    <img *ngIf="itemPartido.header?.imgs[0]" class="img-partido" [src]="_obtenerDatosService.pathPartidos+itemPartido.header?.imgs[0] " />
                                                    <span *ngIf="!itemPartido.header?.imgs[0]" class="font-medium px12" style="width: 90px;"><strong>{{itemPartido.header?.text}}</strong></span>
                                                </div>
                                            </ng-container>

                                        </td>
                                    </tr>
                                    <tr style="border-top: hidden;">
                                        <td class="pdv-0" style="border: none;">
                                            <!-- <span class="px12 font-bold" *ngIf="_globalService.getContienda() == 'diputaciones'">
                                                <strong>Votos</strong>
                                            </span> -->

                                            <span class="px12 font-bold" >
                                                <strong>Total</strong>
                                            </span>
                                        </td>
                                        <td class="text-center pdv-0" *ngFor="let itemPartido of grafica_table; let indx = index;">
                                            <ng-container>
                                                <div>
                                                    <span class="px14 font-bold">
                                                        <strong>{{itemPartido.data?.r1}}</strong>
                                                    </span>
                                                </div>
                                            </ng-container>

                                        </td>
                                    </tr>
                                    <tr class="border3-t-rosaINE ">
                                        <td class="bg-gris-3 pdv-2" style="border: none;">
                                            <span class="px12">
                                                Porcentaje
                                            </span>
                                        </td>
                                        <td *ngFor="let item of grafica_table" class="text-center bg-rosa2 pdv-2">
                                            <span class="px12">
<!--                                                {{item.data?.r2?.toString()?.includes('%') ? item.data?.r2 : item.data?.r2+'%'}}-->
                                                {{item.data?.r2}}
                                            </span>
                                        </td>
                                    </tr>
                                    <!-- <tr class="border3-t-rosaINE ">
                                        <td class="bg-gris-3 pdv-2" style="border: none;">
                                            <span class="px12">
                                                En Casillas
                                            </span>
                                        </td>
                                        <td *ngFor="let item of grafica_table" class="text-center bg-rosa2 pdv-2">
                                            <span class="px12"> -->
<!--                                                {{item.data?.r2?.toString()?.includes('%') ? item.data?.r2 : item.data?.r2+'%'}}-->
                                                <!-- {{item.data?.r3}}
                                            </span>
                                        </td>
                                    </tr> -->
                                    <!-- <tr class="border3-t-rosaINE " *ngIf="!omitirAnticipados">
                                        <td class="bg-gris-3 pdv-2" style="border: none;">
                                            <span class="px12">
                                                Anticipados
                                            </span>
                                        </td>
                                        <td *ngFor="let item of grafica_table" class="text-center bg-rosa2 pdv-2">
                                            <span class="px12"> -->
<!--                                                {{item.data?.r2?.toString()?.includes('%') ? item.data?.r2 : item.data?.r2+'%'}}-->
                                                <!-- {{item.data?.r4}}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr class="border3-t-rosaINE " *ngIf="!omitirPreventivos">
                                        <td class="bg-gris-3 pdv-2" style="border: none;">
                                            <span class="px12">
                                                En Prisión Preventiva
                                            </span>
                                        </td>
                                        <td *ngFor="let item of grafica_table" class="text-center bg-rosa2 pdv-2">
                                            <span class="px12"> -->
<!--                                                {{item.data?.r2?.toString()?.includes('%') ? item.data?.r2 : item.data?.r2+'%'}}-->
                                                <!-- {{item.data?.r5}}
                                            </span>
                                        </td>
                                    </tr> -->
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- TARJETAS MOVIL -->
                <movil-listado-content
                    [selectedItemFunc]="selectedItemFun"
                    [diselectedItemFunc]="diselectedItemFun"
                    [infoList]="fichas"
                    [tipoTarjeta]="4"></movil-listado-content>
                <!--********************************************************************************************************************-->
                <div class="container-fluid">
                    <div class="row dis-flex">
                        <div class="col-md-12">
                            <div class="row dis-flex justify-s">

                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="container-fluid py-4 d-none d-xl-block">
                    <div class="row">
                        <div class="col-md-12 dis-flex justify-e">
                            <i class="fas fa-info-circle mr-2" aria-hidden="true"></i>
                            <p class="texto">
                                Da clic en <strong>Seleccionar</strong> para visualizar el detalle de la votación. Puedes seleccionar hasta tres opciones.
                            </p>
                            <button [disabled]="comparativaService?.arregloElementos.length < 1" (click)="comparativaService.reiniciarModal()" class="boton-detalle btn bgMorado txBlanco btn-sm texto ml-2 px-4 cursorPointer" data-toggle="modal" data-target="#modalComparativa">
                                Ver detalle
                            </button>
                        </div>
                    </div>
                </div> -->
                <!-- <div class="texto font-regular p-3">
                    <p>
                        Por presentación, los decimales de los porcentajes muestran sólo cuatro dígitos. No obstante, al considerar todos los decimales, suman 100%.
                    </p>
                </div> -->

                <app-resumen-votacion
                    [acumulados_num]="resumen?.acumulados?.total"
                    [acumulados_prc]="resumen?.acumulados?.prc"
                    [noregistradas_num]="resumen?.no_registradas?.total"
                    [noregistradas_prc]="resumen?.no_registradas?.prc"
                    [nulos_num]="resumen?.nulos?.total"
                    [nulos_prc]="resumen?.nulos?.prc"
                    [total_num]="resumen?.total?.total"
                    [total_prc]="resumen?.total?.prc"
                    [use_nulos_tooltip]="false"
                    [other_acumulados]="true"
                    [show_second_alternative_legend]="selectedContienda == 'diputaciones'"
                ></app-resumen-votacion>

                <!-- <div class="container-fluid py-4 d-block d-xl-none">
                    <div class="row">
                        <div class="col-md-12 dis-flex justify-e">
                            <button [disabled]="comparativaService?.arregloElementos.length < 1" (click)="comparativaService.reiniciarModal()" class="boton-detalle btn bgMorado txBlanco btn-sm texto ml-2 px-4 cursorPointer" data-toggle="modal" data-target="#modalComparativa">
                                Ver detalle
                            </button>
                        </div>
                    </div>
                </div> -->

            </div>
        </div>
    </div>
</div>
<app-distribucion-votos2 [contienda]="labels?.contienda_s"></app-distribucion-votos2>
<app-votos-extra
    [distrito_param]="rutas.migas?.distrito_clave"
    [omitirAnticipados]="omitirAnticipados"
    [omitirPreventivos]="omitirPreventivos"
    [omitirAnticipadosDem]="omitirAnticipadosDem"
    [omitirPreventivosDem]="omitirPreventivosDem"
></app-votos-extra>
<app-estadistica-nacional
    [tipo_estadistica]="rutas.migas?.distrito"
    [use_custom_data]="true"
    [custom_data]="datosEstadistica"
></app-estadistica-nacional>
<!-- <app-distribucion-votos></app-distribucion-votos>
<app-estadistica-nacional></app-estadistica-nacional> -->
